export const rulesEvaluationTypes = {
  wound: "wound",
  risk: "risk"
  //skin: "skin"//Hidden for Alerts Phase 1
};
